import { createExternalHook } from '../../common/services/external-hooks';

export const onBeforePostCreateHook = createExternalHook();
export const onBeforeCommentCreateHook = createExternalHook();
export const onBeforePostUpdateHook = createExternalHook();
export const onBeforeCommentUpdateHook = createExternalHook();
export const onFetchExternalLinksHook = createExternalHook();
